<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSearchChange">
        </CompositeFormDate>
      </template>
      <!-- 复合搜索框 -->
      <template #beforeBtn>
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`已完成运单`)">导出</el-button>
        </el-form-item>

      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange"
      @onSortChange="onSortChange">
      <template slot="isvoice" slot-scope="params">
        <MySwitch :data="params.params" :activeValue="'2'" :inactiveValue="`1`" @onToggle="toggleDisplay"></MySwitch>
      </template>
      <template slot="times" slot-scope="params">
        <div v-if="params.params.times == 3" class="overTime type3">
          快到期
        </div>
        <div v-if="params.params.times == 1" class="overTime type1">
          未到期
        </div>
        <div v-if="params.params.times == 2" class="overTime type2">
          已到期
        </div>
        <div v-if="params.params.times == 4">
          -
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../mixin";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: 'order',
      formInline: {
        ischeck: 1,
        isstatus: 4,
      },
      formCtrl: [
        {
          label: "过磅单：",
          keyName: "isvoice",
          type: "select",
          options: [
            { label: '全部', value: '' },
            { label: '未回收', value: 1, },
            { label: '已回收', value: 2, },
          ],
        },
        {
          label: "逾期状态：",
          keyName: "intimes",
          type: "select",
          options: [
            { label: '全部', value: '' },
            { label: '未到期', value: 1, },
            { label: '已到期', value: 2, },
            { label: '快到期', value: 3, },
          ],
        },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 150 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "shname", label: "客户名称", minwidth: 120 },
        { keyName: "name", label: "货物名称", minwidth: 120 },
        { keyName: "pricing_name", label: "计价方式", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { keyName: "predict_loading_date", label: "装货日期", minwidth: 120 },
        { keyName: "predict_unloading_date", label: "卸货日期", minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 140 },
        { keyName: "dprice", label: "司机单价", align: 'right', className: 'pr30', minwidth: 140 },
        { keyName: "isvoice", label: "回收过磅单", slot: "isvoice", minwidth: 120 },
        { keyName: "times", label: "是否逾期", slot: "times", minwidth: 120 },
      ],
      btns: [
        {
          class: 'dispatchbtn',
          title: '再派一单',
          img: require('@/assets/img/icon-paidan.png'),
          unimg: require('@/assets/img/icon-paidan-hover.png'),
          cb: ({ id }) => {
            this.$router.push(`/order/nocontractadd?id=${id}`)
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/nocontractview4?id=${id}&mode=edit`
            );
          },
        },
        {
          ...this.feeBtn,
          cb: ({ id, isstatus }) => {
            console.log(id, isstatus)
            let mode = 'view'
            if ([1].includes(this.user.user_group_id)) {
              mode = 'edit'
            }
            this.$router.push(
              `/order/nocontractfee?id=${id}&mode=${mode}`
            );
          },
        },
      ],
    };
  },
  methods: {
    onSearchItemChange({ key }) {
      if (['isvoice', 'intimes'].includes(key)) {
        this.page = 1;
        this.getList()
      }
    },
    onSortChange({ prop, order }) {
      // console.log({ ...column })
      // console.log(prop)
      // console.log(order)
      if (prop) this.formInline['authname'] = prop
      if (order) this.formInline['type'] = (order.replace('ending', ''))
      // console.log({ ...this.formInline })
      this.getList()
    },
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const o = this.dataObjHandler(v)
          o.open = v.isvoice + ''
          return o
        })
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id }) {
      let url = `order/upstatus`;
      const params = {
        // userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    const { user_group_id } = this.user
    if (user_group_id == 1) {
      this.btns.push({
        ...this.delBtn,
        cb: this.delete,
      })
    }
    const viewbtn = {
      ...this.viewBtn,
      cb: ({ id }) => {
        this.$router.push(
          `/order/nocontractview2?id=${id}&mode=view`
        );
      },
    }
    if ([5].includes(user_group_id)) {
      this.btns[1] = viewbtn
    }
    const feebtn = this.btns[2]
    if ([2, 3, 4].includes(user_group_id)) {
      this.btns = [
        viewbtn,
        feebtn,
      ]
    }
  },
};
</script>

<style lang="less" scoped>
.table-wrap {
  /deep/ .el-table {
    .el-switch {
      &.inactive {
        .el-switch__core::after {
          content: '否';
          line-height: 17px;
          text-indent: 18px;
          color: #fff;
        }
      }

      &.active {
        .el-switch__core::after {
          content: '是';
          line-height: 17px;
          text-indent: -34px;
          color: #fff;
        }
      }
    }

    .overTime {
      // width: 14px;
      // height: 14px;
      // border-radius: 100%;
      // display: inline-block;
      // vertical-align: top;
      // margin-top: 7px;
      color: #F88623;

      &.type1 {
        color: #45A814;
      }

      &.type2 {
        color: #E61E1E;
      }
    }
  }
}

/deep/ .el-button.is-circle {
  padding: 5px;
  color: #96999f;
  background: #f2f6fc;
}
</style>
